function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "arrow",
  d: "M16.7 2.25L2.3 16l14.4 13.75",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 19 32",
    width: 19,
    height: 32
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/lft_arrow.8f35ea22.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/svgs/lft_arrow.svg
// module id = 757
// module chunks = 0